import { MultiselectItem } from '@cokitchen/cokitchen-components/dist/form/multiselect/types';
import { createContext, useContext } from 'react';
import { CreateBrandFormType, PolygonType } from 'utils/types';

export type BrandContextType = {
  createBrandForm: CreateBrandFormType;
  setCreateBrandForm: (k: CreateBrandFormType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  companyOptions: MultiselectItem[];
  loadingCompanyOptions: boolean;
  availablePolygons: PolygonType[];
  loadingPolygons: boolean;
};

export const NewBrandContext = createContext({} as BrandContextType);

const useNewBrandContext = () => {
  const context = useContext(NewBrandContext);
  return context;
};

export default useNewBrandContext;
